import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {userInviteActions} from "_actions";
import {UserInvitesBuilder} from "../objects/UserInvitesBuilder";
import UserInviteStatus from "../../UserInvite/UserInviteStatus";
import UserInviteActions from "../../UserInvite/UserInviteActions";
import {capitalizeFirstCharOnly, formatToDate} from "_helpers";
import {formatRole} from "../UserInviteUtils";

export default function ({organization, inviteStatus, search, offset}) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(userInviteActions.list({organization, inviteStatus, search, offset}));
    }, [organization, inviteStatus, search, offset]);

    const userInvites = useSelector(state => state.userInvite.userInvites);
    const loading = useSelector(state => state.userInvite.loadingInvites);
    const userInviteList = userInvites?.invites || [];
    const totalCount = userInvites?.totalCount || 0;
    const rows = [];

    if(!loading && userInviteList.length > 0) {
        userInviteList.map( userInvite => {
            const builder = new UserInvitesBuilder();
            const date = formatToDate(userInvite?.dateCreated, 'MMM DD hh:mm A z');
            builder.setEmail(userInvite?.invitedUser?.email || userInvite?.email || '-');
            builder.setInvitedBy(userInvite?.invitedBy?.email || '-');
            builder.setOrganizationName(userInvite?.organization?.name || '-');
            builder.setRole(formatRole(userInvite?.role?.authority) || '-');
            builder.setDateCreated(capitalizeFirstCharOnly(date));
            builder.setStatus(<UserInviteStatus inviteStatus={userInvite?.inviteStatus}/>);
            builder.setActions(<UserInviteActions userInvite={userInvite}/>);

            rows.push(builder.userInvite);
        });
    }

    const columns = [
        {
            id: 'email',
            label: 'Email',
            width: 150,
            isSortable: true,
        },
        {
            id: 'organizationName',
            label: 'Organization',
            width: 150,
            isSortable: true,
        },
        {
            id: 'invitedBy',
            label: 'Invited By',
            width: 170,
            isSortable: true,
        },
        {
            id: 'role',
            label: 'Role',
            width: 150,
            isSortable: true,
        },
        {
            id: 'dateCreated',
            label: 'Date Created',
            width: 150,
            isSortable: true,
        },
        {
            id: 'inviteStatus',
            label: 'Status',
            width: 100,
        },
        {
            id: 'actions',
            label: 'Actions',
            width: 5,
            align: 'right',
        },
    ];

    return { rows, columns, totalCount, loading };
}